import React from "react";
import { Upload } from "antd";
import ImgCrop from "antd-img-crop";
import useUploadOss from "../../../../../hooks/useUploadOss";
import styles from "./index.less";

const SelectFrontCover = props => {
  const { coverUrl, onChange, tips } = props;

  const { upload } = useUploadOss({
    options: {
      prefix: "push_cover_",
      onOk: uploadUrl => {
        if (onChange) {
          onChange(uploadUrl);
        }
      }
    }
  });

  const imgCropProps = {
    rotate: false,
    aspect: 75 / 32
  };

  const handleUploadCover = file => {
    upload(file.file);
  };

  return (
    <div className={styles.root}>
      <ImgCrop {...imgCropProps}>
        <Upload
          customRequest={handleUploadCover}
          listType="picture-card"
          fileList={[]}
        >
          <div className="checked-item">
            <div
              className="item-img"
              style={{ backgroundImage: `url(${coverUrl})` }}
            />
          </div>
        </Upload>
      </ImgCrop>
      {tips && <div className="tips">{tips}</div>}
    </div>
  );
};

export default SelectFrontCover;
